import { useLayout } from "context/layout/layout";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PortalService } from "services/portal";
import logo from "../../../assets/white.png";

export function PortalForgotPassword() {
  const layout = useLayout();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      return layout.errorAlert({ message: "Ingresa tu correo electronico" });
    }

    setLoading(true);
    try {
      await PortalService.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      layout.errorAlert({ message: "Error al enviar solicitud" });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "0.75rem 1rem",
    fontSize: "0.95rem",
    border: "1.5px solid #e2e8f0",
    borderRadius: "0.625rem",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    background: "#fff",
    color: "#1e293b",
    boxSizing: "border-box",
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "48px",
          maxWidth: "440px",
          width: "100%",
          boxShadow: "0 4px 6px rgba(0,0,0,0.07)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "2rem" }}>
          <img src={logo} alt="Profit" style={{ width: "120px", marginBottom: "1.5rem", filter: "invert(1)" }} />
          <h2 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#0f172a", marginBottom: "0.5rem" }}>
            Recuperar contrasena
          </h2>
          <p style={{ fontSize: "0.875rem", color: "#64748b" }}>
            {sent
              ? "Revisa tu bandeja de entrada"
              : "Ingresa tu correo para recibir instrucciones"}
          </p>
        </div>

        {sent ? (
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                width: "64px",
                height: "64px",
                borderRadius: "50%",
                background: "#ecfdf5",
                color: "#059669",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "28px",
              }}
            >
              &#10003;
            </div>
            <p style={{ color: "#475569", fontSize: "0.9rem", marginBottom: "24px", lineHeight: 1.6 }}>
              Si el correo <strong>{email}</strong> esta registrado, recibiras un enlace para restablecer tu contrasena.
            </p>
            <Link
              to="/portal/login"
              style={{
                display: "inline-block",
                padding: "0.75rem 2rem",
                background: "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
                color: "#fff",
                borderRadius: "0.625rem",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Volver al login
            </Link>
          </div>
        ) : (
          <form autoComplete="on" onSubmit={(e) => e.preventDefault()}>
            <div style={{ marginBottom: "1.75rem" }}>
              <label style={{ display: "block", fontSize: "0.8rem", fontWeight: 600, color: "#334155", marginBottom: "0.5rem" }}>
                Correo electronico
              </label>
              <input
                type="email"
                placeholder="nombre@empresa.cl"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
                autoComplete="email"
                style={inputStyle}
                onFocus={(e) => {
                  e.target.style.borderColor = "#0353a4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(3,83,164,0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              type="button"
              style={{
                width: "100%",
                padding: "0.8rem",
                fontSize: "0.95rem",
                fontWeight: 600,
                color: "#fff",
                background: loading
                  ? "#64748b"
                  : "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
                border: "none",
                borderRadius: "0.625rem",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s",
                boxShadow: "0 2px 8px rgba(15,23,42,0.25)",
                marginBottom: "1rem",
              }}
            >
              {loading ? "Enviando..." : "Enviar instrucciones"}
            </button>

            <p style={{ textAlign: "center", fontSize: "0.85rem", color: "#64748b" }}>
              <Link
                to="/portal/login"
                style={{ color: "#0353a4", textDecoration: "none", fontWeight: 600 }}
              >
                Volver al login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
